module.exports = __webpack_public_path__ + "static/media/DSC_0059.f33c93b3.jpg";